// extracted by mini-css-extract-plugin
module.exports = {"columns":"_3BQmz"};